module.exports = __webpack_public_path__ + "img/car-light.5b638721.svg";